import { render, staticRenderFns } from "./proList.vue?vue&type=template&id=6bac68d1&scoped=true"
import script from "./proList.vue?vue&type=script&lang=js"
export * from "./proList.vue?vue&type=script&lang=js"
import style0 from "./proList.vue?vue&type=style&index=0&id=6bac68d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac68d1",
  null
  
)

export default component.exports